/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Audio_Description_PluginInputs */

const en_team_manager_audio_description_plugin = /** @type {(inputs: Team_Manager_Audio_Description_PluginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Description Plugin`)
};

const fr_team_manager_audio_description_plugin = /** @type {(inputs: Team_Manager_Audio_Description_PluginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plug-in de description audio`)
};

const de_team_manager_audio_description_plugin = /** @type {(inputs: Team_Manager_Audio_Description_PluginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibungs-Plugin`)
};

const it_team_manager_audio_description_plugin = /** @type {(inputs: Team_Manager_Audio_Description_PluginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin di descrizione audio`)
};

const ru_team_manager_audio_description_plugin = /** @type {(inputs: Team_Manager_Audio_Description_PluginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плагин аудиоописания`)
};

const es_team_manager_audio_description_plugin = /** @type {(inputs: Team_Manager_Audio_Description_PluginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento de descripción de audio`)
};

const zh_cn2_team_manager_audio_description_plugin = /** @type {(inputs: Team_Manager_Audio_Description_PluginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频描述插件`)
};

const ja_team_manager_audio_description_plugin = /** @type {(inputs: Team_Manager_Audio_Description_PluginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ説明プラグイン`)
};

const hi_team_manager_audio_description_plugin = /** @type {(inputs: Team_Manager_Audio_Description_PluginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण प्लगइन`)
};

const pt_pt2_team_manager_audio_description_plugin = /** @type {(inputs: Team_Manager_Audio_Description_PluginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin de descrição de áudio`)
};

/**
* | output |
* | --- |
* | "Audio Description Plugin" |
*
* @param {Team_Manager_Audio_Description_PluginInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_audio_description_plugin = /** @type {((inputs?: Team_Manager_Audio_Description_PluginInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Audio_Description_PluginInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_audio_description_plugin(inputs)
	if (locale === "de") return de_team_manager_audio_description_plugin(inputs)
	if (locale === "it") return it_team_manager_audio_description_plugin(inputs)
	if (locale === "ru") return ru_team_manager_audio_description_plugin(inputs)
	if (locale === "es") return es_team_manager_audio_description_plugin(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_audio_description_plugin(inputs)
	if (locale === "ja") return ja_team_manager_audio_description_plugin(inputs)
	if (locale === "hi") return hi_team_manager_audio_description_plugin(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_audio_description_plugin(inputs)
	return en_team_manager_audio_description_plugin(inputs)
});